module.exports = __webpack_public_path__ + "zarif.jpg?ed01fb1dfe731e5dcc13f799d6591c21";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projetos/zarif.jpg
// module id = 161
// module chunks = 0